import { Validators } from "@angular/forms";
import moment = require("moment");
import { IFormKey } from "src/app/modules/shared/models/forms";

export interface IRegistryAdjustmentRequest {
    policyNumber: string;
    firstName: string;
    lastName: string;
}

export const registry_adjustment_form_validators = {
    cognome: [Validators.required],
    nome: [Validators.required],
    codiceFiscale: [Validators.required, Validators.pattern(/^[A-Z]{6}[0-9]{2}[A-Z][0-9]{2}[A-Z][A-Z0-9]{4}$/)],
    sesso: [Validators.required],
    dataNascita: [Validators.required],
    statoNascita: [Validators.required],
    provinciaNascita: [Validators.required],
    comuneNascita: [Validators.required]
}

export const registry_adjustment_form_keys: IFormKey[] = [
    {
        id: 'cognome-field',
        label: 'Cognome',
        controlName: 'cognome',
        css: 'col-3',
        type: 'INPUT'
    },
    {
        id: 'nome-field',
        label: 'Nome',
        controlName: 'nome',
        css: 'col-3',
        type: 'INPUT'
    },
    {
        id: 'codice-fiscale-field',
        label: 'Codice fiscale',
        controlName: 'codiceFiscale',
        css: 'col-3',
        type: 'INPUT'
    },
    {
        id: 'sesso-field',
        label: 'Sesso',
        controlName: 'sesso',
        css: 'col-3',
        type: 'SELECT',
        options: [
            {
                key: 'M',
                value: 'Maschio'
            },
            {
                key: 'F',
                value: 'Femmina'
            },
        ]
    },
    {
        id: 'data-nascita-field',
        controlName: 'dataNascita',
        label: 'Data di nascita',
        css: 'col-3',
        type: 'DATEPICKER',
        maxDate: moment()
    },
    {
        id: 'stato-nascita-field',
        label: 'Stato di nascita',
        controlName: 'statoNascita',
        css: 'col-3',
        type: 'SELECT',
        options: []
    },
    {
        id: 'provincia-nascita-field',
        label: 'Provincia di nascita',
        controlName: 'provinciaNascita',
        css: 'col-3',
        type: 'SELECT',
        options: []
    },
    {
        id: 'comune-nascita-field',
        label: 'Comune di nascita',
        controlName: 'comuneNascita',
        css: 'col-3',
        type: 'SELECT',
        options: []
    }
];